<template>
 <div class="container-fluid">
     <!-- static-pages -->
     <div class="row bg-white">
         <div class="static-pages">
             <div class="static-pages-title bg-grey-l ">
                 <!-- title -->
                 <div class="container">
                     <div class="col-xs-12 returns-header">
                         <div class="title text-bold">
                             <h1>RETURNS AND EXCHANGES</h1>
                         </div>
                         <button @click="goToSubmitTicket()" class="btn btn-green btn-outline ipad-portrait">SUBMIT A TICKET</button>
                     </div>
                 </div>
                 <!-- /.title -->
             </div>
             <!-- static-pages-content -->
             <div class="static-pages-content p-t p-b-xl">
                 <div class="container">
                     <div class="col-xs-12 clearfix">
                         <h2 class="text-center">BLD Returns Policy</h2>
                         <p>
                             If you have any issues while using the System or would like to exercise any of your rights under this Warranty, please submit a ticket at nzxt.com/support or contact us directly on live chat or phone from 8am-8pm PST or by calling NZXT’s support team at 800-228-9395. If NZXT’s
                             support team cannot resolve your issue, they will issue you a Return Merchandize Authorization (“RMA”) number. PLEASE DO NOT SHIP ANY SYSTEM BEFORE YOU RECEIVE YOUR RMA NUMBER.
                         </p>

                         <p>
                             Once you have received your RMA number, pack the System in its original packaging or a well-protected box, as outlined in the NZXT Packing Instructions available here.
                             <strong>
                                 NZXT recommends that you keep the original packaging in which the System was delivered
                                 to you in case of a return.
                             </strong>
                             If you do not have the original or compatible packaging to return the defective portions of your System, you can contact NZXT’s support team at 800-228-9395 or
                             <a class="mailto" href="mailto:bldsupport@nzxt.com">bldsupport@nzxt.com</a> who will provide you a shipping box and packaging material at cost. NZXT WILL NOT BE RESPONSIBLE FOR SHIPPING DAMAGE OR LOSSES OR FOR ANY PRODUCT NOT PURCHASED DIRECTLY FROM NZXT.
                         </p>
                         <p>
                             NZXT will never charge you for labor or phone support for repairs covered by this Warranty.
                         </p>
                         <p>
                             Please ensure that your RMA Number is prominently and clearly displayed on the outside of your return packaging. Please pack the System with a copy of your bill of sale or other proof of purchase, your name, address, phone number, description of the problem(s),
                             and the RMA number you have obtained.
                         </p>
                         <p>
                             If you contact NZXT about an issue with your System within thirty days from the date the System is delivered to you, NZXT will cover all ground shipping costs associated with your issue. If you contact NZXT after such period, NZXT will cover one-way ground
                             shipping costs associated with your issue. NZXT provides return labels/pay for return shipping costs for Hawaii, Alaska, and Canada. Assembly fees and shipping costs will not be refunded.
                         </p>

                         <p>
                             NZXT will attempt to ship the System or any replacement parts back to you within two weeks from the date NZXT receives your Shipment, but cannot guarantee compliance with this timeframe. Replacement parts for your System will be comparable, but may not
                             necessarily be the same as the original part.
                         </p>

                         <h3>General Packing Instructions.</h3>

                         <p>
                             NZXT Inc. advises shipping the computer in the original box and packing materials. If the original box and materials are no longer available, please call your shipper to receive specifications for shipping a package through them.&nbsp; We recommend UPS,
                             FedEx or any other shipping company that uses tracking technology. Alternatively, you can contact NZXT’s support team at 800-228-9395 or <a class="mailto" href="mailto:bldsupport@nzxt.com">bldsupport@nzxt.com</a>
                             who will provide you a shipping box and packaging material at cost.
                         </p>
                         <p>
                             Return the products in their original packaging, in as-new condition, along with any media, documentation and any other items that were included in your original shipment.
                         </p>
                         <p>
                             YOUR RMA NUMBER MUST BE CLEARLY MARKED ON THE OUTSIDE OF THE BOX OR PACKAGE. TAPE A NOTE TO THE SIDE OF YOUR COMPUTER, INSIDE THE BOX OR PACKAGE. THIS NOTE SHOULD INCLUDED:
                         </p>
                         <p>
                             YOUR FULL NAME, ADDRESS, RMA NUMBER, DAYTIME PHONE NUMBER AND PROBLEM(S) DESCRIPTION.
                         </p>

                         <h3>Full System Packing Instructions.</h3>
                         <p>
                             The box should able to handle a weight of 40~50 lbs.
                         </p>
                         <p>
                             There should be a minimum of 3” of space on all six sides of the computer.
                         </p>
                         <p>
                             The 3” space shall be fitted with BLOCK FOAM material. Make sure the material will absorb an impact if dropped.
                         </p>
                         <p>
                             We do not recommend foam popcorn/peanuts, newspaper, pieces of cardboard, blankets etc. These materials tend to shift in the box and allow the computer to move and make contact with the sides of the box.
                         </p>
                         <p>
                             Use heavy-duty 3” packing tape rated at 60 lbs. to seal the package. Do not use masking tape - the driver will not accept the package.
                         </p>
                         <p>
                             When you ship your NZXT Inc. product in for repair or credit, NZXT is not liable or responsible for freight damage. It is recommended that you insure the package in the event that your NZXT product is received freight damaged, you may be able to file
                             a claim with your shipper.
                         </p>
                         <p>
                             ALL DAMAGE WILL DELAY THE RETURN OF YOUR COMPUTER
                         </p>

                         <h3>Your Responsibilities.</h3>
                         <p>
                             In order for NZXT to provide you with the best possible service under this Warranty, you agree to:
                         </p>

                         <h3>Parts Packing Instructions.</h3>
                         <p>
                             Individual parts must be handled in a similar manner:
                         </p>
                         <p>
                             The parts must have sufficient protection to prevent damage, use anti-static bag for memory and peripherals.
                         </p>
                         <p>
                             Hard drives, Floppy drives, CD-ROMS and peripherals must be boxed. Never use an envelope. These parts are sensitive to being dropped or crushed.
                         </p>
                         <p>
                             Any package received damaged will be kept in the receiving department and the Technical Support and Customer Service Supervisors will be contacted in order to contact you regarding the damage. You will then be advised to file a claim with the shipping
                             company.
                         </p>
                         <p>
                             If you have any questions regarding this limited warranty, return policy or packing instructions, please E-mail us at: <a class="mailto" href="mailto:bldsupport@nzxt.com">bldsupport@nzxt.com</a>.
                         </p>
                     </div>
                 </div>
             </div>
             <!-- static-pages-content -->
         </div>
     </div>
     <!-- /.static-pages -->
 </div>
</template>

<script>
export default {
    methods: {
        goToSubmitTicket() {
            // User is not logged in
            if (!Cookies.get("cookies_id")) {
                this.$router.push({ name: 'UserAccount', query: {
                    redirect: '/user/account',
                    currentTab: 'create-tickets'
                }});
            } else {
                this.$router.push({ name: 'UserAccount', query: { currentTab: 'create-tickets'}})
            }
        }
    }
}
</script>

<style lang="scss">
.returns-header {
    display: flex;
    justify-content: space-between;
    padding: 40px 0;

    @media screen and (max-width: 768px) and (min-width: 320px) {
        padding: 25px 0;
    }

    @media screen and (max-width: 480px) and (min-width: 320px) {
        flex-direction: column;
        padding: 25px 30px;

        & h1 {
            text-align: center;
            margin-bottom: 15px;
        }
    }
}

@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px)
and (orientation : portrait) {
    .ipad-portrait {
        padding: 10px 20px !important;
    }
}

</style>
